import styled from "styled-components";
import { IMAGES } from "../../constants/images";
import { useCallback, useEffect, useState } from "react";

export default function ResetHorth() {
  const [bearing, setBearing] = useState(0);

  useEffect(() => {
    const map = window.map;
    if (!map) return;

    const updateBearing = () => {
      const bearingValue = map.getBearing();
      setBearing((prev) => (prev !== bearingValue ? bearingValue : prev));
    };

    map.on("rotate", updateBearing);
    map.on("pitch", updateBearing);

    return () => {
      map.off("rotate", updateBearing);
      map.off("pitch", updateBearing);
    };
  }, []);

  const handleReset = useCallback(() => {
    const map = window.map;
    if (!map) return;

    map.easeTo({ bearing: 0, pitch: 0, duration: 500 });
    setBearing(0);
  }, []);

  return (
    <Button onClick={handleReset}>
      <img src={IMAGES.PANORAME} alt="Panorame" style={{ transform: `rotate(${-bearing + 45}deg)` }} />
    </Button>
  );
}

const Button = styled.button`
  all: unset;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 20px;
  bottom: 159px;
  height: 34px;
  width: 34px;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #ececec;
  }
`;
